<template>
  <div>
    <!-- Page Header -->
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("attributes") }}</h4>
        </div>
      </div>

<!--      <ul class="table-top-head">-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--        </li>-->
<!--      </ul>-->

      <div class="page-btn">
        <router-link to="/attribute/create" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_attribute") }}
        </router-link>
      </div>
    </div>

    <!-- Card -->
    <div class="card table-list-card">
      <!-- Table -->
      <div class="table-responsive p-3">
        <!-- TABLE -->
        <div class="card p-3">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>SL</th>
                <th>Name</th>
                <th>Values</th>
                <th width="300">Add Value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(attr, index) in attributes" :key="attr.id">
                <td>{{ index + 1 }}</td>
<!--                <td>{{ attr.name }}</td>-->
                <td>
                  <div v-if="!attr.editing_name">
                    {{ attr.name }}
                    <i
                      class="ti ti-edit text-primary ms-1"
                      style="cursor:pointer"
                      @click="enableAttrEdit(attr)"
                    ></i>
                  </div>

                  <div v-else class="d-flex gap-2">
                    <input
                      v-model="attr.temp_name"
                      class="form-control form-control-sm"
                      @keyup.enter="updateAttribute(attr)"
                    />

                    <i
                      class="ti ti-check text-success"
                      style="cursor:pointer"
                      @click="updateAttribute(attr)"
                    ></i>

                    <i
                      class="ti ti-x text-danger"
                      style="cursor:pointer"
                      @click="cancelAttrEdit(attr)"
                    ></i>
                  </div>
                </td>

                <td>
                  <div class="d-flex flex-wrap gap-2">
                    <div
                      v-for="v in attr.values"
                      :key="v.id"
                      class="border rounded px-2 py-1 bg-light"
                    >
                      <!-- Display Mode -->
                      <div v-if="!v.editing" class="d-flex align-items-center">
                        <span>{{ v.value }}</span>

                        <i
                          class="ti ti-edit text-primary ms-2"
                          style="cursor: pointer"
                          @click="enableValueEdit(v)"
                        ></i>
                      </div>

                      <!-- Edit Mode -->
                      <div v-else class="d-flex align-items-center gap-2">
                        <input
                          v-model="v.temp_value"
                          class="form-control form-control-sm"
                          style="min-width: 120px;"
                          @keyup.enter="updateValue(attr, v)"
                        />

                        <i
                          class="ti ti-check text-success"
                          style="cursor: pointer"
                          @click="updateValue(attr, v)"
                        ></i>

                        <i
                          class="ti ti-x text-danger"
                          style="cursor: pointer"
                          @click="cancelValueEdit(v)"
                        ></i>
                      </div>
                    </div>
                  </div>
                </td>

                <!-- ADD VALUE -->
                <td>
                  <div class="d-flex gap-2">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="attr.new_value"
                      placeholder="Add value"
                    />

                    <button
                      class="btn btn-sm btn-primary"
                      :disabled="attr.loading"
                      @click="addValue(attr)"
                    >
                      Add
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiUrls from "@/urls";
import {useToast} from "vue-toastification";

export default {

  data() {
    return {
      attributes: []
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {

    async fetchAttributes() {
      const res = await this.$axios.get(apiUrls.attribute.get);

      this.attributes = res.data.map(a => ({
        ...a,
        new_value: "",
        loading: false
      }));
    },

    async addValue(attr) {
      const value = attr.new_value?.trim();

      if (!value) {
        this.toast.error("Value required");
        return;
      }

      attr.loading = true;

      try {

        const res = await this.$axios.post(
          `/attributes/${attr.id}/add-values/`,
          {
            values: [value]
          }
        );

        const data = res.data;

        // CREATED VALUES
        if (data.created?.length) {
          data.created.forEach(v => {
            attr.values.push({
              id: Date.now() + Math.random(),
              value: v
            });
          });

          this.toast.success(`Value added successfully`);
        }

        // SKIPPED VALUES (ALREADY EXISTS)
        if (data.skipped?.length) {
          this.toast.warning(
            `${data.skipped.join(", ")} already exists`
          );
        }

        attr.new_value = "";

      } catch (err) {

        console.log(err.response?.data);

        this.toast.error("Failed");

      } finally {
        attr.loading = false;
      }
    },

    enableAttrEdit(attr) {
      attr.editing_name = true;
      attr.temp_name = attr.name;
    },

    cancelAttrEdit(attr) {
      attr.editing_name = false;
      attr.temp_name = attr.name;
    },

    async updateAttribute(attr) {

      const name = (attr.temp_name || "").trim();

      if (!name) {
        this.toast.error("Name required");
        return;
      }

      try {

        await this.$axios.patch(
          `/attributes/${attr.id}/`,
          { name }
        );

        attr.name = name;
        attr.editing_name = false;

        this.toast.success("Attribute updated");

      } catch (err) {

        this.toast.error(
          err.response?.data?.name?.[0] || "Update failed"
        );

      }
    },

    enableValueEdit(v) {
      v.editing = true;
      v.temp_value = v.value;
    },

    cancelValueEdit(v) {
      v.editing = false;
      v.temp_value = v.value;
    },

    async updateValue(attr, v) {

      const value = (v.temp_value || "").trim();

      if (!value) {
        this.toast.error("Value required");
        return;
      }

      try {
        const res = await this.$axios.patch(
          `/attribute/values/${v.id}/`,
          { value }
        );

        v.value = res.data.value;
        v.editing = false;

        this.toast.success("Value updated");

      } catch (err) {

        this.toast.error(
          err.response?.data?.value?.[0] || "Update failed"
        );
      }
    },

  },

  created() {
    this.fetchAttributes();
  }

};
</script>

